

$("document").ready(function() {

  
  if ($('.termekeinkSkrollr').length > 0) {
    $("document").scrollTop(0);
    var s = skrollr.init();
  
  
    setSize();
    $(window).on('resize', function(){
      setSize();
    });
    function setSize() {
      
      if($(window).width()>1440) {
        var currentHeight = $(window).height()*10;
        console.log(currentHeight);
      } else if($(window).width()>1280) {
        var currentHeight = $(window).height()*15;
        console.log(currentHeight);
      } else if($(window).width()>990) {
        var currentHeight = $(window).height()*18;
        console.log(currentHeight);
      } else {
        var currentHeight = $(window).height()*28;
      }
      
      
      $('.termekeinkSkrollr').css('height',currentHeight+'px');
    }
  }




  AOS.init();

  
  if ($('.hamburger').length > 0) {
    $('.hamburger').bind('click',function() { 
      
      $(this).toggleClass('is-active');
      $('.mobileMenu').slideToggle();
    
      return false;
    });

    $('.mobileMenu.menu-item-has-children a').click(function() { 
      $(this).parent().find('.sub-menu').slideToggle();
      $(this).toggleClass('active');
      return false;
    });

  

    
  }
  
  
  if ($('.testimonialCarousel').length > 0) {
  
    $('.testimonialCarousel').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,      
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,    
      responsive: [
      {
          breakpoint: 991,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false

          }
      },
      {
        breakpoint: 769,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false

        }
    }

      ]
  });

  }
  if ($('.partnerCarousel').length > 0) {
  
    $('.partnerCarousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,      
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,    
      responsive: [
      {
          breakpoint: 991,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true

          }
      },
      {
        breakpoint: 769,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true

        }
    }

      ]
  });

  }
  if ($('.termeloCarousel').length > 0) {
  
    $('.termeloCarousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,      
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'linear',      
      responsive: [
      {
          breakpoint: 576,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true

          }
      }

      ]
  });

  }
  if ($('.videoCarousel').length > 0) {
  
    $('.videoCarousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,      
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,    
      responsive: [
      {
          breakpoint: 991,
          settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true

          }
      },
      {
        breakpoint: 769,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true

        }
    },
    {
      breakpoint: 576,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      arrows: true

      }
  },
  {
    breakpoint: 421,
    settings: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true

    }
}

      ]
  });

  }
  

  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
  }
 
  

  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-100
        }, 1000);
        return false;
    }
    }
});

});